// 统一为图片设置默认加载与解码策略，避免大量图片阻塞首屏渲染
const DEFAULT_LOADING = 'lazy'
const DEFAULT_DECODING = 'async'

export const applyImageDefaults = (root = document) => {
  if (!root || !root.querySelectorAll) return

  const images = root.querySelectorAll('img')
  images.forEach((img) => {
    const isEager =
      img.dataset.eager === 'true' || img.getAttribute('loading') === 'eager'

    if (!img.decoding) {
      img.decoding = DEFAULT_DECODING
    }
    if (!img.loading && !isEager) {
      img.loading = DEFAULT_LOADING
    }
  })
}

export const initImageDefaults = () => {
  const apply = () => applyImageDefaults(document)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true })
    return
  }

  apply()
}
